var map = {
	"./ansible-svgrepo-com.svg": 9718,
	"./aws-svgrepo-com.svg": 2745,
	"./c.svg": 6152,
	"./css3.svg": 3005,
	"./docker-svgrepo-com.svg": 8312,
	"./git.svg": 5299,
	"./github-142-svgrepo-com.svg": 2225,
	"./grafana-svgrepo-com.svg": 7778,
	"./html5.svg": 7219,
	"./java.svg": 2273,
	"./javascript.svg": 8596,
	"./jenkins-svgrepo-com.svg": 636,
	"./kubernetes-svgrepo-com.svg": 6300,
	"./linux-svgrepo-com.svg": 7320,
	"./maven-svgrepo-com.svg": 243,
	"./mongodb.svg": 7797,
	"./mysql.svg": 1257,
	"./postgresql.svg": 5927,
	"./postman.svg": 1285,
	"./prometheus-svgrepo-com.svg": 1104,
	"./python.svg": 2327,
	"./spring.svg": 4158,
	"./terraform-icon-svgrepo-com.svg": 4062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8977;